import { FormDataArgs, JsonFormDataArgs } from '../constants/constants';

type getFleNameProps = {
  student: string;
  birthYear: string;
  extension?: 'pdf' | 'json';
};

export const getFileName = ({
  student,
  birthYear,
  extension,
}: getFleNameProps) => {
  const fullName = student?.replaceAll(' ', '_');
  const fileName = `${fullName}_${birthYear}${extension ? '.' + extension : ''}`;

  return fileName;
};

export const addMetaData = (data: FormDataArgs) => {
  const withMetaData: JsonFormDataArgs = {
    formData: data,
    metaData: {
      version: '2.0.0',
      creationDate: new Date().toISOString(),
    },
  };

  return withMetaData;
};

export const clearEmptyValues = (
  obj: Record<string, any>,
): Record<string, any> => {
  const result: Record<string, any> = {};
  // TODO will break in many circumstances, fix
  for (const [key, value] of Object.entries(obj)) {
    if (Array.isArray(value)) {
      const cleanedArray = value.filter((value) => value);
      if (cleanedArray.length > 0) {
        result[key] = cleanedArray;
      }
    } else if (typeof value === 'object' && value !== null) {
      const cleanedObject = clearEmptyValues(value);
      if (Object.keys(cleanedObject).length > 0) {
        result[key] = cleanedObject;
      }
    } else if (value !== undefined && value !== null && value !== '') {
      result[key] = value;
    }
  }

  return result;
};
